"use client";

import { useTranslations } from "next-intl";
import { hasDocumentedProductQualityClaims } from "@/config/catalog-product-policy";

/** Shared product quality statement across listing cards and product details. */
export function ProductQualityNote({ slug }: { slug?: string } = {}) {
	const t = useTranslations("kitWebsite.unit");
	if (!hasDocumentedProductQualityClaims(slug)) return null;
	return (
		<p className="mt-1 text-xs font-medium leading-relaxed text-muted-foreground">
			{t(slug === "bac-water-10ml" ? "coaBadge" : "quality")}
		</p>
	);
}
